<template>
  <el-form label-width="90px" @submit.native.prevent>
    <div v-show="!isCollapsed">

      <el-form-item label="標題">
        <el-input v-model="form[formKey].Title" @input="onTitleInput"></el-input>
      </el-form-item>

      <el-form-item label="次標題">
        <el-input v-model="form[formKey].SubTitle"></el-input>
      </el-form-item>

      <el-form-item label="出貨提醒">
        <el-input v-model="form[formKey].ShippingHint"></el-input>
      </el-form-item>

      <el-form-item label="自取地址">
        <el-input v-model="form[formKey].PickupAddress"></el-input>
      </el-form-item>

      <!-- <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="el-upload-images"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genCoverImageFileParam())">
          <img
            ref="coverImg"
            v-show="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            @load="e => onImageLoaded(e, genCoverImageFileParam())"
            class="preview"
            :src="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form[formKey].CoverImageURLX1 || form[formKey]['coverObjectURL'])" class="el-icon-upload"></i>

        </el-upload>

        <p class="hint">請上傳 1920x1080的圖片。</p>
      </el-form-item> -->

      <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="el-upload-images"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genCoverImageFileParam())">
          <img
            ref="coverImg"
            v-show="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            @load="e => onImageLoaded(e, genCoverImageFileParam())"
            class="preview"
            :src="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form[formKey].CoverImageURLX1 || form[formKey]['coverObjectURL'])" class="el-icon-upload"></i>
          <!-- <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div> -->
        </el-upload>

        <img v-for="(img,idx) in form[formKey].imagesJsonArr" :key="`team-buying-${formKey}-image-${idx}`"
          class="img-images"
          @dblclick="confirmDeleteImage(idx)"
          :src="img['@1']"/>
        <br>
        <p class="hint">請上傳 1080x1080的圖片。連點可刪除圖片。</p>
      </el-form-item>

      <el-form-item label="訂購流程">
        <c-k-editor-form ref="form-Tw" @input="onProcessContentInput" :value="form[formKey].ProcessContents"></c-k-editor-form>
      </el-form-item>

    </div>

    <div style="padding-left: 120px;">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form[formKey].contentJsonArr" />
    </div>

  </el-form>
</template>

<script>
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import CKEditorForm from '@/views/webpages/form-ckeditor'
export default {
  mixins: [MixinProcessImageFile],
  components: {
    ContentEditor,
    CKEditorForm
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    },
    formKey: {
      default: ''
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      // discount image
      isProcessingDiscountImage: false,

      pickerOptions: {
        disabledDate (time) {
          return time.getFullYear() < 2022
        }
      }
    }
  },
  computed: {
    tags () {
      return this.$store.state.teamBuyingTag.list
    },
    isEdit () {
      return this.$route.name !== 'createTeamBuying'
    }
  },
  methods: {
    onProcessContentInput () {
      this.form[this.formKey].ProcessContents = this.$refs['form-Tw'].getHTML()
    },
    // cover image
    genCoverImageFileParam () {
      let requiredSize = { w: 1080, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'elupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'coverImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'coverObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'CoverImageURLX3',
          'CoverImageURLX2',
          'CoverImageURLX1'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          },
          {
            maxWidth: requiredSize.w * 2 / 3,
            maxHeight: requiredSize.h * 2 / 3
          },
          {
            maxWidth: requiredSize.w / 3,
            maxHeight: requiredSize.h / 3
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'coverImageBlob@3x',
          'coverImageBlob@2x',
          'coverImageBlob@1x'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `team-buying/${this.form.ID}/cover-`
            : `team-buying/cover@3x-${this.form[this.formKey].Name}-`,
          this.isEdit
            ? `team-buying/${this.form.ID}/cover-`
            : `team-buying/cover@2x-${this.form[this.formKey].Name}-`,
          this.isEdit
            ? `team-buying/${this.form.ID}/cover-`
            : `team-buying/cove-@1x-${this.form[this.formKey].Name}-`
        ],
        // 上傳後 callback
        onImageUploaded: () => {
          let newImg = {
            '@3': this.form[this.formKey].CoverImageURLX3,
            '@2': this.form[this.formKey].CoverImageURLX2,
            '@1': this.form[this.formKey].CoverImageURLX1
          }
          if (!this.form[this.formKey].imagesJsonArr) {
            this.$set(this.form[this.formKey], 'imagesJsonArr', [newImg])
          } else {
            this.form[this.formKey].imagesJsonArr.push(newImg)
          }
          this.form[this.formKey].CoverImageURLX3 = ''
          this.form[this.formKey].CoverImageURLX2 = ''
          this.form[this.formKey].CoverImageURLX1 = ''
        }
      }
      return params
    },
    onTitleInput () {
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/"/g, '')
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/#/g, '')
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/\//g, '')
      this.$emit('title-changed', this.form[this.formKey].Name)
    },
    confirmDeleteImage (idx) {
      if (window.confirm('確定刪除此圖片?')) {
        this.form[this.formKey].imagesJsonArr.splice(idx, 1)
      }
    }
  },
  created () {
    this.form[this.formKey].contentJsonArr = this.form[this.formKey].Contents
      ? JSON.parse(this.form[this.formKey].Contents)
      : []
    this.form[this.formKey].imagesJsonArr = this.form[this.formKey].Images
      ? JSON.parse(this.form[this.formKey].Images)
      : []
  }
}
</script>

<style>
.discount-wrapper {
  margin-top: 30px;
  padding: 25px 84px 25px 0;
  background-color: rgb(247, 247, 247);

  align-items: center;
  display: inline-flex;
}

.el-upload-discount {
  height: 90px;
  display: inline-block;
}

.el-upload-discount .el-upload-dragger {
  width: 90px;
  height: 90px;
}

.el-upload-discount .el-upload__text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: center;
  color: rgb(112, 112, 112);
}

.el-upload-images {
  height: 100px;
  float: left;
  display: inline-block;
}

.el-upload-images .el-upload-dragger {
  width: 100px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.el-upload-images .el-icon-upload {
  margin: 0 !important;
}

.img-images {
  width: 100px;
  height: 100px;
  display: inline-block;
  float: left;
  margin-left: 15px;
}

.hint {
  display: block;
  width: 100%;
  float: left;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  color: #666;
}
</style>
